import apiFetch from '../../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `Bioseguridad/deleteSeleccionBioSeguridad`, method: 'POST', body: list, token: token})
}
